module.exports = __webpack_public_path__ + "img/blaze_hero_mobile.16900199.png";